export const LOCATION_GEO_BUTTON_CONFIG = [
  {
    title: "EagleView ConnectExplorer",
    icon: "/assets/eagle-view-icon.svg",
    url: "https://explorer.eagleview.com/index.php?lat={lat}&lon={lon}&angle=Or&zoom=19&orientation=N"
  },
  {
    title: "Google Maps",
    icon: "/assets/google-maps.svg",
    url: "https://www.google.com/maps?q={lat},{lon}"
  },
  {
    title: "Google Earth",
    icon: "/assets/google-earth.svg",
    url: "https://earth.google.com/web/@{lat},{lon},3000a,0d,0y,0h,0t,0r"
  },
  {
    title: "Google Street View",
    icon: "/assets/google-street.svg",
    url: "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint={lat},{lon}"
  },
  {
    title: "OpenStreetMap Viewer",
    icon: "/assets/open-street-map-logo.svg",
    url: "https://www.openstreetmap.org/?mlat={lat}&mlon={lon}#map=18/{lat}/{lon}"
  },
  {
    title: "National Weather Services",
    icon: "/assets/nation-weather-service-logo.svg",
    url: "https://forecast.weather.gov/MapClick.php?lat={lat}&lon={lon}"
  },
  {
    title: "USGS Topographical Map",
    icon: "/assets/usgs-map-logo.svg",
    url: "https://ngmdb.usgs.gov/topoview/viewer/#14/{lat}/{lon}"
  },
];